// 初期設定
import { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useLocation, useNavigate } from "react-router-dom";
import { Header } from '../header/Header';
import { Footer } from '../footer/Footer';
import { Logout } from '../common/Logout';
import * as CommonUtil from '../common/CommonUtil';
import * as PagingUtil from '../common/PagingUtil';
import PageProps from '../types/pageProps';

function UnauthorizedError(props:PageProps) {
    const navigate = useNavigate();
    const location = useLocation();

    //フッター表示用State
    const [displayFooter, setDisplayFooter] = useState(false);

    // 初期処理
    useEffect(() => {
        const initResult = CommonUtil.initialize(true, false, props.pageNavigator, location);
        if (!initResult['workable']) {
            return initResult['cleanup'];
        }

        CommonUtil.setIndicator(true);
        Logout().finally(() => {
            CommonUtil.setIndicator(false);
            // ログイン画面へ遷移
            PagingUtil.resetAndNext("/userLogin", navigate);
        })

        setDisplayFooter(true);
        return initResult['cleanup'];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    // 画面設定
    return (
        <div>

            <HelmetProvider>
                <Helmet>
                    <title>エラー | JAF救援要請ウェブサイト</title>
                </Helmet>
            </HelmetProvider>
            <Header hideMenu pageNavigator={props.pageNavigator}/>

            <Footer display={displayFooter}/>
        </div>
    )
}
 
export default UnauthorizedError
